export function hasOwnProviderCredentials(paymentCredentials, provider) {
    return Boolean(paymentCredentials && paymentCredentials.provider === provider);
}

export function getPaymentProviderUiStatus(provider, {
    business,
    paymentCredentials,
    verifStatus,
    requireVerified = false,
    activationUnlocked = false,
} = {}) {
    const isSelected = activationUnlocked || business?.pmtProvider === provider;
    const hasOwnCredentials = hasOwnProviderCredentials(paymentCredentials, provider);

    if (isSelected && hasOwnCredentials && (!requireVerified || business?.verified === true)) {
        return "ACTIVE";
    }

    if (isSelected && (activationUnlocked || verifStatus > 0) && (!hasOwnCredentials || (requireVerified && business?.verified !== true))) {
        return "IN_PROGRESS";
    }

    return "NOT_ACTIVATED";
}

export function isCredentialOverlayLocked(provider, business, credentialsUnlocked = false) {
    return !credentialsUnlocked && business?.pmtProvider !== provider;
}
